module.exports = "<post-editor post=\"post\" form-id=\"formId\" ng-if=\"formId\"></post-editor>\n";